import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    events: [],
    eventsLoading: false,
    triggerEvents: [],
    triggerEventsLoading: false,
  },
  mutations: {
    setEvents(state, events) {
      state.events = events;
    },
    setEventsLoading(state, loading) {
      state.eventsLoading = loading;
    },
    setTriggerEventsLoading(state, loading) {
      state.eventsLoading = loading;
    },
    setTriggerEvents(state, triggerEvents) {
      state.triggerEvents = triggerEvents;
    },
  },
  actions: {
    async loadEvents({ commit, dispatch, rootState }) {
      commit("setEventsLoading", true);
      // console.log(rootState.settings);
      let events = await api.get("events", {
        params: { dateRange: rootState.settings.dateRange },
      });
      // console.log(events);
      commit("setEvents", events.data);
      commit("setEventsLoading", false);
      dispatch("loadTriggerEvents");
    },
    async loadTriggerEvents({ state, commit }) {
      commit("setTriggerEventsLoading", true);
      let triggerEvents = state.events.filter(
        (e) => e.type == "trigger" && e.imageType
      );
      commit("setTriggerEvents", triggerEvents);
      commit("setTriggerEventsLoading", false);
    },
    async downloadEventAttachment({ commit }, event) {
      window.open(
        `https://api.flexi-comms.com/events/downloadAttachment?id=${event.id}&imageType=${event.imageType}`,
        "_blank"
      );
    },
  },
  getters: {
    eventsLoading(state) {
      return state.eventsLoading;
    },
    events(state) {
      return state.events;
    },
    triggerEvents(state) {
      return state.triggerEvents;
    },
    triggerEventsLoading(state) {
      return state.triggerEventsLoading;
    },
  },
};
